import { render, staticRenderFns } from "./CompanyDetailsBodySkeleton.vue?vue&type=template&id=66c4d16c&scoped=true&"
import script from "./CompanyDetailsBodySkeleton.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetailsBodySkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c4d16c",
  null
  
)

export default component.exports